<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  components: {
    PageTable,
  },
}
</script>
